export default "__VITE_ASSET__85b96a88__"